import React from 'react';

export const Search: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="4 4 16 16" {...props}>
    <path
      d="M18.829 18.004l-3.981-3.981a5.552 5.552 0 10-.825.825L18 18.829a.583.583 0 10.825-.825zm-8.287-3.087a4.375 4.375 0 114.375-4.375 4.38 4.38 0 01-4.375 4.375z"
      fill="currentColor"
    />
  </svg>
);
